export default __webpack_public_path__ + "static/media/Mercenary's Jerkin of Crouching Calm.20032f71.jpg";